import _ from 'underscore'
import Backbone from '@polleverywhere/backbone'
import BEM from '@polleverywhere/toolkit-lib/lib/mixins/_bem'
import Oauth2Redirect from '../oauth2_redirect'
import tmpl from '../../templates/sso/provider.hamlc'

// eslint-disable-line import/no-webpack-loader-syntax
export default class Provider extends Backbone.View {
  get template () { return tmpl }
  get className () { return 'component-auth__sso-providers__provider' }
  get tagName () { return 'button' }
  get events () {
    return {
      click: () => {
        this.trigger('view:action', 'click:oauth_signin',
          { provider: this.name },
          { immediate: true }
        )
        return this.handleSignIn()
      }
    }
  }

  /**
  * @param {Object} options Configuration options.
  * @param {String} options.name Name of sso service provider
  * @param {String} options.icon Provider icon xml (typically svg, but could be html)
  * @param {String} options.label String that is written on the sign in button
  * @param {Function} options.callbackFn (Oauth2Redirect) -> {} Function called when signin button clicked
  */
  initialize (options = {}) {
    _.extend(this, BEM(this))

    const requiredOptions = [
      'name',
      'icon',
      'label',
      'callbackFn'
    ]

    requiredOptions
      .forEach(key => {
        if (!options[key]) {
          throw new Error(`options.${key} is required`)
        }
      })

    this.name = options.name
    this.icon = options.icon
    this.label = options.label

    const oauth2Redirect = new Oauth2Redirect()
    oauth2Redirect.provider = this.name

    this.handleSignIn = () =>
      Promise.resolve(
        options.callbackFn(oauth2Redirect)
      )
        .catch(err =>
          this.trigger('error', err)
        )
  }

  render () {
    super.render()
    this.$el.html(this.template)
    this.$_toggleModifier(null, this.className, this.name, true)
    this.$_element('icon').html(this.icon)
    this.$_element('label').text(this.label)
    this.trigger('view:action', 'view:oauth_signin',
      { provider: this.name }
    )
    return this
  }
}
